export default "__VITE_ASSET__B3df90wk__"